import {Component, OnInit} from '@angular/core';
import {ModalController, NavController} from "@ionic/angular";
import {NavigationService} from "../shared/service/navigation.service";

@Component({
  selector: 'app-register-feature',
  templateUrl: './register-feature.page.html',
  styleUrls: ['./register-feature.page.scss'],
})
export class RegisterFeaturePage implements OnInit {

  features: {
    icon: string,
    title: string,
    color: string,
    description: string
  }[] = [
    {
      title: 'Sponsorizza i tuoi eventi',
      icon: 'public',
      color: 'var(--azzurro--300',
      description: 'Inserisci eventi locali (concerti, mostre, iniziative) per aiutare la community a rimanere informata.'
    },
    {
      title: 'Preferiti',
      icon: 'favorite',
      color: 'var(--magenta--500)',
      description: 'Salva i tuoi eventi e ricevi una notifica quando è il momento giusto!'
    }
  ];

  constructor(private modalCtrl: ModalController,
              private navigationService: NavigationService) {
  }

  ngOnInit() {
  }

  onDismiss(){
    this.modalCtrl.dismiss();
  }

  onRegister(){
    this.navigationService.forwardModal('login');
  }

}
